import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';
import { useAuthContext } from 'modules/auth/context';

/**
 * For a learner with no goal, such as an account made before the questionnaire
 * existed: one step to set it, which turns on today's test. Nothing for anyone else.
 */
export function SetGoalCard() {
  const { t } = useTranslation();
  const { state } = useAuthContext();
  if (!state.user || state.user.learnerProfile) return null;

  return (
    <section aria-labelledby="set-goal-title" className="flex flex-col gap-4 rounded-lg border border-border bg-card p-5 sm:flex-row sm:items-center sm:justify-between md:p-6">
      <div className="min-w-0">
        <h2 id="set-goal-title" className="text-[15px] font-semibold text-foreground">{t('studyPlan.home_set_goal_title')}</h2>
        <p className="mt-1 max-w-xl text-sm leading-relaxed text-muted-foreground">{t('studyPlan.home_set_goal_body')}</p>
      </div>
      <Button asChild className="shrink-0">
        <Link to="/portal/settings/plan">{t('studyPlan.set_goal')}</Link>
      </Button>
    </section>
  );
}

export default SetGoalCard;
